export type AppLocale = 'pt' | 'en';

export type ContactFormCopy = {
  button: string;
  sending: string;
  success: string;
  submitError: string;
};

export type ValidationMessages = {
  required: string;
  invalidEmail: string;
  invalidPhone: string;
  invalidName: string;
};

export type ContactFormI18n = {
  copy: ContactFormCopy;
  validation: ValidationMessages;
};

export function normalizeLocale(locale?: string): AppLocale {
  return locale?.toLowerCase().startsWith('pt') ? 'pt' : 'en';
}

export const CONTACT_FORM_I18N: Record<AppLocale, ContactFormI18n> = {
  pt: {
    copy: {
      button: 'Enviar',
      sending: 'A enviar...',
      success:
        'Recebemos a sua mensagem. A nossa equipa entrará em contacto em breve.',
      submitError:
        'Não foi possível enviar a sua mensagem. Por favor, tente novamente.',
    },
    validation: {
      required: 'Por favor, preencha este campo.',
      invalidEmail: 'Por favor, introduza um email válido.',
      invalidPhone: 'Por favor, introduza um número de telefone válido.',
      invalidName: 'Por favor, introduza o seu nome completo.',
    },
  },
  en: {
    copy: {
      button: 'Submit',
      sending: 'Sending...',
      success:
        'We received your message. Our team will get back to you shortly.',
      submitError: 'We could not send your message. Please try again.',
    },
    validation: {
      required: 'Please fill out this field.',
      invalidEmail: 'Please enter a valid email address.',
      invalidPhone: 'Please enter a valid phone number.',
      invalidName: 'Please enter your full name.',
    },
  },
};
